module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "box-sizing": "border-box"
    },
    attrs: {
      "id": "sinfo"
    }
  }, [_c('iframe', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "printf",
      "src": "",
      "width": "0",
      "height": "0",
      "frameborder": "0"
    }
  }), _vm._v(" "), (_vm.resumeInfo) ? _c('div', {
    staticClass: "com-model"
  }, [_c('header', {
    staticClass: "flex flex-between"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "flex top"
  }, [_c('div', {
    staticClass: "back-c",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "top-tit"
  }, [_vm._v("简历详情")])]), _vm._v(" "), _c('div', {
    staticClass: "flex bottom"
  }, [_c('span', [_vm._v("应聘岗位："), _c('font', [_vm._v(_vm._s(_vm.resumeInfo.workerInfo.recruitTitle || '无'))])], 1), _vm._v(" "), (_vm.resumeInfo.workerInfo.recruitTitle) ? [_c('span', {
    staticClass: "post-status"
  }, [_vm._v("招聘中")]), _vm._v(" "), _c('span', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('span', [_vm._v("发布时间：" + _vm._s(_vm.recruitInfo.createdAt.split(' ')[0]))])] : _vm._e()], 2)]), _vm._v(" "), _c('el-steps', {
    attrs: {
      "space": 100,
      "active": _vm.stepActive
    }
  }, [_c('el-step', {
    attrs: {
      "title": "简历下载",
      "icon": "circle-check"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "简历筛选",
      "icon": "circle-check"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "通过面试",
      "icon": "circle-check"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "入职上岗",
      "icon": "circle-check"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "body-content",
    staticStyle: {
      "padding": "34px 24px 24px 0"
    },
    attrs: {
      "id": "printOrder-data"
    }
  }, [_c('div', {
    staticClass: "marginLeft",
    style: ((_vm.flex + " " + _vm.flexBetween + " margin-bottom: 28px;"))
  }, [_c('div', {
    style: ((_vm.flex + " margin-top: 50px;"))
  }, [(_vm.resumeInfo.workerInfo.headImage) ? _c('img', {
    staticClass: "person",
    staticStyle: {
      "width": "68px",
      "height": "68px",
      "border-radius": "34px",
      "margin-right": "16px"
    },
    attrs: {
      "src": _vm.resumeInfo.workerInfo.headImage,
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "person",
    staticStyle: {
      "width": "68px",
      "height": "68px",
      "border-radius": "34px",
      "margin-right": "16px"
    },
    attrs: {
      "src": "//oss.51ztx.com/resu.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "name",
    staticStyle: {
      "font-weight": "bold",
      "font-size": "22px",
      "color": "#141414",
      "line-height": "28px",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.resumeInfo.workerInfo.name) + "\n              "), _c('img', {
    staticClass: "icon-sex",
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-left": "6px"
    },
    attrs: {
      "src": _vm.IconSex,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "oinfo flex",
    style: ((_vm.flex + " font-size: 16px; color: rgba(51,51,51,0.85); line-height: 14px;"))
  }, [_c('font', [_vm._v(_vm._s(_vm.resumeInfo.workerInfo.sex || '不限'))]), _vm._v(" "), (_vm.resumeInfo.workerInfo.age) ? _c('span', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.resumeInfo.workerInfo.age) + "岁\n              ")]) : _vm._e(), _vm._v(" "), (_vm.resumeInfo.workerInfo.educationName) ? _c('span', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.resumeInfo.workerInfo.educationName) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.resumeInfo.workerInfo.homeProvincename && _vm.resumeInfo.workerInfo.homeCityname) ? _c('span', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.resumeInfo.workerInfo.homeProvincename) + _vm._s(_vm.resumeInfo.workerInfo.homeCityname) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.resumeInfo.workerInfo.experience) ? _c('span', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.resumeInfo.workerInfo.experience) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.resumeInfo.workerInfo.phone) ? _c('span', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.resumeInfo.workerInfo.phone) + "\n              ")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    style: ((_vm.flex + " margin-bottom: 20px; align-items: flex-start;"))
  }, [_c('div', {
    style: (_vm.iItem)
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "color": "#5C6874",
      "line-height": "20px",
      "margin-bottom": "8px"
    }
  }, [_vm._v("更新日期")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "color": "#2A2F4C",
      "line-height": "20px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.resumeInfo.workerInfo.updatedAt.split(" ")[0]) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "i-item flex flex-column align-start",
    style: (_vm.iItem)
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "color": "#5C6874",
      "line-height": "20px",
      "margin-bottom": "8px"
    }
  }, [_vm._v("最近浏览岗位")]), _vm._v(" "), _c('div', {
    style: (("" + _vm.flex))
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "color": "#2A2F4C",
      "line-height": "20px",
      "margin-right": "7px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.resumeInfo.workerInfo.latelyBrowse || '无') + "\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "88px",
      "height": "22px",
      "border-radius": "4px",
      "font-size": "16px",
      "text-align": "center",
      "line-height": "22px"
    },
    style: ({
      color: _vm.getActivityStatus.color,
      backgroundColor: _vm.getActivityStatus.bg
    })
  }, [_vm._v("\n              " + _vm._s(_vm.getActivityStatus.text) + "\n            ")])])])]), _vm._v(" "), (!_vm.resumeInfo.remark) ? _c('div', {
    staticStyle: {
      "height": "50px",
      "width": "1px"
    }
  }) : _c('div', {
    staticClass: "remake-box",
    staticStyle: {
      "padding": "15px",
      "background-color": "rgba(243, 247, 255, 1)"
    }
  }, [_c('div', {
    staticClass: "remake-operate flex align-start",
    style: (("" + _vm.flex + _vm.alignStart))
  }, [_c('img', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "src": require("../../assets/images/home/icon_remke_msg.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "word-wrap": "break-word",
      "width": "calc(100% - 53px)",
      "font-size": "14px",
      "color": "#5C6874",
      "line-height": "20px",
      "margin": "0 10px"
    }
  }, [_vm._v("\n            " + _vm._s(("备注：" + (_vm.resumeInfo.remark))) + "\n          ")]), _vm._v(" "), _c('el-dropdown', {
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('i', {
    staticClass: "el-icon-more"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    staticStyle: {
      "color": "rgba(0, 0, 0, 1)"
    },
    attrs: {
      "command": "ReamkeEdit"
    },
    on: {
      "click": _vm.handleReamkeEdit
    }
  }, [_c('i', {
    staticClass: "el-icon-edit"
  }), _vm._v(" 编辑备注\n              ")]), _vm._v(" "), _c('el-dropdown-item', {
    staticStyle: {
      "color": "rgba(253, 107, 109, 1)"
    },
    attrs: {
      "command": "ReamkeDel"
    },
    on: {
      "click": _vm.handleReamkeDel
    }
  }, [_c('i', {
    staticClass: "el-icon-delete"
  }), _vm._v("删除\n              ")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#5C6874",
      "line-height": "17px",
      "padding-right": "150px",
      "padding-bottom": "27px",
      "border-bottom": "1px solid #EFEFEF",
      "margin-bottom": "37px"
    }
  }), _vm._v(" "), (_vm.resumeInfo.ecpList.length) ? [_c('div', {
    style: (_vm.boxTitle)
  }, [_vm._v("求职期望")]), _vm._v(" "), _c('div', {
    style: ((_vm.flex + " margin-bottom: 36px;"))
  }, _vm._l((_vm.resumeInfo.ecpList), function(item) {
    return _c('div', {
      key: item.workerId,
      style: (_vm.ecpItem)
    }, [_c('div', {
      staticStyle: {
        "font-size": "16px",
        "color": "rgba(42, 47, 76, 1)",
        "font-weight": "500",
        "line-height": "20px",
        "margin-bottom": "8px"
      }
    }, [_vm._v("\n              " + _vm._s(item.positionName) + "\n            ")]), _vm._v(" "), _c('div', {
      style: ((_vm.flex + " font-size: 14px;color:rgba(51, 51, 51, 1);"))
    }, [_c('font', [_vm._v(_vm._s(item.cityName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "1px",
        "height": "14px",
        "background": "#D8D8D8",
        "margin": "0 12px"
      }
    }), _vm._v(" "), (item.minSalary) ? _c('font', [_vm._v(_vm._s(((item.minSalary) + "-" + (item.maxSalary))))]) : _vm._e()], 1)])
  }))] : _vm._e(), _vm._v(" "), _c('div', {
    style: (_vm.boxTitle)
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    style: ((_vm.flex + " flex-wrap: wrap; margin-bottom: 36px; font-size: 14px; color: #666; line-height: 20px;"))
  }, [_c('span', {
    staticStyle: {
      "margin-bottom": "16px",
      "width": "230px"
    }
  }, [_vm._v("姓 名：" + _vm._s(_vm.resumeInfo.workerInfo.name))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "16px",
      "width": "calc(100% - 230px)"
    }
  }, [_vm._v("\n          年龄：" + _vm._s(_vm.resumeInfo.workerInfo.age) + "\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "16px",
      "width": "230px"
    }
  }, [_vm._v("\n          工作经历：" + _vm._s(_vm.resumeInfo.workerInfo.experience) + "\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "16px",
      "width": "calc(100% - 230px)"
    }
  }, [_vm._v("\n          联系电话：" + _vm._s(_vm.resumeInfo.workerInfo.phone) + "\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "16px",
      "width": "230px"
    }
  }, [_vm._v("\n          籍 贯：" + _vm._s(_vm.resumeInfo.workerInfo.homeProvincename) + _vm._s(_vm.resumeInfo.workerInfo.homeCityname) + "\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "16px",
      "width": "calc(100% - 230px)"
    }
  }, [_vm._v("\n          联系地址：" + _vm._s(_vm.resumeInfo.workerInfo.address) + "\n        ")])]), _vm._v(" "), _c('div', {
    style: (_vm.boxTitle)
  }, [_vm._v("个人优势")]), _vm._v(" "), (_vm.advantageList.length) ? _c('div', {
    style: (_vm.advantage)
  }, _vm._l((_vm.advantageList), function(adv, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(adv))])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "line-height": "20px",
      "margin-bottom": "36px"
    }
  }, [_vm._v("\n        自我描述：" + _vm._s(_vm.resumeInfo.workerInfo.brief) + "\n      ")]), _vm._v(" "), _c('div', {
    style: (_vm.boxTitle)
  }, [_vm._v("工作经历")]), _vm._v(" "), (_vm.resumeInfo.expList.length) ? _c('div', {
    staticStyle: {
      "padding-left": "28px",
      "margin-bottom": "36px"
    }
  }, _vm._l((_vm.resumeInfo.expList), function(item, index) {
    return _c('div', {
      key: item.id,
      staticStyle: {
        "position": "relative",
        "display": "flex",
        "padding-bottom": "30px"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "10px",
        "height": "10px",
        "background-color": "rgba(5, 125, 249, 1)",
        "border-radius": "50%",
        "margin-right": "16px",
        "margin-top": "4px"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex": "1"
      }
    }, [_c('div', {
      staticClass: "item-exp-bi flex flex-between"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('span', [_vm._v(_vm._s(item.positionName))]), _vm._v(" "), _c('span', {
      staticClass: "split-line-bi"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.companyName))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "14px",
        "color": "rgba(92, 104, 116, 1)",
        "line-height": "20px"
      }
    }, [_vm._v("\n                " + _vm._s(item.inTime.split(" ")[0]) + " ~ " + _vm._s(item.outTime.split(" ")[0]) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "14px",
        "line-height": "20px",
        "color": "#666"
      }
    }, [_vm._v("\n              工作内容："), _c('span', {
      staticStyle: {
        "color": "#333333"
      },
      domProps: {
        "innerHTML": _vm._s(item.workDesc.replace(/\n/g, '<br>'))
      }
    })])]), _vm._v(" "), (index < _vm.resumeInfo.expList.length - 1) ? _c('div', {
      staticStyle: {
        "width": "1px",
        "height": "100%",
        "position": "absolute",
        "left": "4.36px",
        "top": "13px",
        "border-left": "1px dashed rgba(4, 15, 36, 0.20)"
      }
    }) : _vm._e()])
  })) : _c('div', {
    staticStyle: {
      "margin-bottom": "36px",
      "font-size": "14px",
      "color": "#666",
      "line-height": "20px"
    }
  }, [_vm._v("暂无工作经历")]), _vm._v(" "), _c('div', {
    style: (_vm.boxTitle)
  }, [_vm._v("视频介绍")]), _vm._v(" "), (_vm.resumeInfo.videoUrl) ? _c('div', {
    staticClass: "video-box m-b-18",
    on: {
      "click": _vm.showVideo
    }
  }, [_c('img', {
    staticClass: "video",
    attrs: {
      "src": _vm.resumeInfo.videoUrl + '?vframe/jpg/offset/0',
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video-title"
  }, [_vm._v("视频简历")]), _vm._v(" "), _c('img', {
    staticClass: "video-btn",
    attrs: {
      "src": require("../../assets/images/resume/video_play_icon.png"),
      "alt": ""
    }
  })]) : _c('div', {
    staticStyle: {
      "margin-bottom": "36px",
      "font-size": "14px",
      "color": "#666",
      "line-height": "20px"
    }
  }, [_vm._v("暂无视频上传")])], 2), _vm._v(" "), _c('div', {
    staticClass: "feedback-btn flex flex-center",
    on: {
      "click": function($event) {
        _vm.feedbackVisible = true
      }
    }
  }, [_c('span', {
    staticClass: "flex flex-center"
  }, [_vm._v("?")])]), _vm._v(" "), (!_vm.resumeInfo.remark) ? _c('el-button', {
    staticStyle: {
      "position": "absolute",
      "top": "350px",
      "left": "110px"
    },
    on: {
      "click": _vm.handleReamkeEdit
    }
  }, [_vm._v("\n      添加备注\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "status-btns"
  }, [(!_vm.resumeInfo.workerInfo.isFavorite) ? _c('el-button', {
    attrs: {
      "icon": "star-off"
    },
    on: {
      "click": function($event) {
        _vm.onCommit(3)
      }
    }
  }, [_vm._v("收藏")]) : _c('el-button', {
    staticClass: "btn-active",
    attrs: {
      "icon": "star-on"
    },
    on: {
      "click": function($event) {
        _vm.onCommit(3)
      }
    }
  }, [_vm._v("已收藏")]), _vm._v(" "), (!_vm.resumeInfo.workerInfo.isColl) ? _c('el-button', {
    on: {
      "click": _vm.handleColl
    }
  }, [_vm._v("下载简历")]) : _vm._e(), _vm._v(" "), (_vm.resumeInfo.workerInfo.isColl) ? _c('el-button', {
    on: {
      "click": _vm.doPrintVue
    }
  }, [_vm._v("打印简历")]) : _vm._e(), _vm._v(" "), (!_vm.isCol && !_vm.resumeEliminate && _vm.resumeInfo.workerInfo.isColl) ? [([1, 2, 11, 12].includes(_vm.resumeInfo.status)) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onCommit(4)
      }
    }
  }, [_vm._v("约面试")]) : _vm._e(), _vm._v(" "), ([4].includes(_vm.resumeInfo.status)) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.failViewVisible2 = true
      }
    }
  }, [_vm._v("面试通过")]) : _vm._e(), _vm._v(" "), ([6].includes(_vm.resumeInfo.status)) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onCommit(8)
      }
    }
  }, [_vm._v("不上岗")]) : _vm._e(), _vm._v(" "), ([1, 2, 11, 12, 4, 6].includes(_vm.resumeInfo.status)) ? _c('el-button', {
    on: {
      "click": _vm.handleResumeSG
    }
  }, [_vm._v("已上岗")]) : _vm._e(), _vm._v(" "), ([4].includes(_vm.resumeInfo.status)) ? _c('el-button', {
    staticClass: "btn-danger",
    on: {
      "click": function($event) {
        _vm.failViewVisible = true
      }
    }
  }, [_vm._v("\n          不通过\n        ")]) : _vm._e()] : _vm._e(), _vm._v(" "), ([1, 2, 11, 12, 6].includes(_vm.resumeInfo.status) && !_vm.isCol) ? _c('el-button', {
    staticClass: "btn-danger",
    on: {
      "click": function($event) {
        _vm.onCommit(1)
      }
    }
  }, [_vm._v("\n        不合适\n      ")]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频预览",
      "visible": _vm.videoVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      }
    }
  }, [(_vm.videoUrl && _vm.videoVisible) ? _c('video', {
    attrs: {
      "src": _vm.videoUrl,
      "autoplay": ""
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.isModalShow) ? _c('div', {
    staticClass: "modal",
    class: {
      fadeIn: _vm.isModalShow, fadeOut: !_vm.isModalShow
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-con"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "modal-con-main"
  }, [_c('div', {
    staticClass: "m-header"
  }, [_c('span', [_vm._v("确认操作")]), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-guanbi",
    on: {
      "click": function($event) {
        _vm.isModalShow = !_vm.isModalShow
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-content"
  }, [(_vm.isPass) ? _c('div', {
    staticClass: "zf-txt"
  }, [_vm._v("\n              请确认 "), _c('span', {
    staticClass: "zf-name"
  }, [_vm._v(_vm._s(_vm.resumeInfo.name))]), _vm._v("已通过面试 并支付 "), _c('span', {
    staticClass: "zf-yuan"
  }, [_vm._v(_vm._s(_vm.carsubsidy) + "元面试车补")]), _vm._v("给他吗？\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.isPass) ? _c('div', {
    staticClass: "zf-txt"
  }, [_vm._v("\n              您确认 "), _c('span', {
    staticClass: "zf-name"
  }, [_vm._v(_vm._s(_vm.resumeInfo.name))]), _vm._v("不合适吗？您将支付 "), _c('span', {
    staticClass: "zf-yuan"
  }, [_vm._v(_vm._s(_vm.carsubsidy) + "元面试车补")]), _vm._v("给他吗？\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zf-yems"
  }, [_vm._v("\n              账户余额："), _c('span', {
    staticClass: "zf-ye"
  }, [_vm._v(_vm._s(_vm.availableFunds) + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "zf-zftxt",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('p', [_vm._v("请输入支付密码")]), _vm._v(" "), (_vm.passwordError) ? _c('p', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0",
      "color": "#dc1010",
      "font-size": "14px"
    }
  }, [_vm._v("\n                请输入支付密码")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "passwordType",
    staticClass: "zf-input",
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "autocomplete": "new-password",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-grpups"
  }, [_c('div', {
    staticClass: "m-cancel-button",
    on: {
      "click": function($event) {
        _vm.isModalShow = !_vm.isModalShow
      }
    }
  }, [_vm._v("下次再说")]), _vm._v(" "), _c('div', {
    staticClass: "m-confirm-button",
    on: {
      "click": _vm.payInterview
    }
  }, [_vm._v("确认支付")])])])])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-fail-view",
    attrs: {
      "title": "面试不通过",
      "visible": _vm.failViewVisible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.failViewVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "fail-text"
  }, [_vm._v("确认该候选人未通过面试，信息也会同步告知ta。")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("面试人有到场吗")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.radio1),
      callback: function($$v) {
        _vm.radio1 = $$v
      },
      expression: "radio1"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("已面试")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("未面试")])], 1)], 1), _vm._v(" "), (_vm.recruitInfo && _vm.recruitInfo.provideCarsubsidy) ? _c('div', {
    staticClass: "bg-text"
  }, [_c('img', {
    staticClass: "bg-icon",
    attrs: {
      "src": require("../../assets/images/home/icon_bt.png"),
      "alt": ""
    }
  }), _vm._v("\n        该岗位已设置车补¥"), _c('font', [_vm._v(_vm._s(_vm.recruitInfo.carsubsidy))]), _vm._v("/人，确认后将从账户余额同步扣除\n      ")], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.failViewVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onCommit(5)
      }
    }
  }, [_vm._v("确认不通过")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-fail-view",
    attrs: {
      "title": "确认面试通过",
      "visible": _vm.failViewVisible2,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.failViewVisible2 = $event
      }
    }
  }, [_c('div', {
    staticClass: "fail-text"
  }, [_vm._v("确认该候选人面试通过，现在要给ta办理上岗")]), _vm._v(" "), (_vm.recruitInfo && _vm.recruitInfo.provideCarsubsidy) ? _c('div', {
    staticClass: "bg-text"
  }, [_c('img', {
    staticClass: "bg-icon",
    attrs: {
      "src": require("../../assets/images/home/icon_bt.png"),
      "alt": ""
    }
  }), _vm._v("\n        该岗位已设置车补¥"), _c('font', [_vm._v(_vm._s(_vm.recruitInfo.carsubsidy))]), _vm._v("/人，确认后将从账户余额同步扣除\n      ")], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.onCommit(6)
      }
    }
  }, [_vm._v("面试通过暂不上岗")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onCommit(9)
      }
    }
  }, [_vm._v("确认上岗")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-feedback",
    attrs: {
      "title": " ",
      "visible": _vm.feedbackVisible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.feedbackVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("请反馈您的问题")]), _vm._v(" "), _c('div', {
    staticClass: "feed-text"
  }, [_vm._v("感谢您的反馈、我们会尽快处理！")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.feedbackInfo.type),
      callback: function($$v) {
        _vm.$set(_vm.feedbackInfo, "type", $$v)
      },
      expression: "feedbackInfo.type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("电话联系失败")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("内容作假")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("下载失败")])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请描述您在使用中遇到的问题"
    },
    model: {
      value: (_vm.feedbackInfo.content),
      callback: function($$v) {
        _vm.$set(_vm.feedbackInfo, "content", $$v)
      },
      expression: "feedbackInfo.content"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.feedbackVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleReportFd
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), (_vm.confirmVisible) ? _c('Confirm', _vm._b({
    attrs: {
      "visible": _vm.confirmVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.confirmVisible = $event
      }
    }
  }, 'Confirm', _vm.confirmInfo, false)) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isLogOff) ? _c('div', {
    staticClass: "log-off"
  }, [_vm._m(0, false, false)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "log-off-content"
  }, [_c('img', {
    staticClass: "log-off-icon",
    attrs: {
      "src": require("../../assets/images/icon_log_off.png"),
      "alt": "注销图标"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "log-off-title"
  }, [_vm._v("用户已注销")]), _vm._v(" "), _c('div', {
    staticClass: "log-off-desc"
  }, [_vm._v("用户已将自己的账号注销，所属内容已无法查看")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2af84085","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resume/info.vue
// module id = 863
// module chunks = 1